import { Component, Input, ViewEncapsulation } from '@angular/core';
import { Icon } from '../icons/svg-icon.component';

export enum ButtonType {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  TEXT = 'text',
}

export enum ButtonPosition {
  LEFT = 'left',
  RIGHT = 'right',
  CENTER = 'center',
}

export enum IconPosition {
  LEFT = 'left',
  RIGHT = 'right',
}

export interface ButtonIcon {
  name: Icon;
  position: IconPosition;
}

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ButtonComponent {
  buttonType = ButtonType;
  iconPosition = IconPosition;
  ButtonPosition = ButtonPosition;

  @Input() type: ButtonType = ButtonType.PRIMARY;
  @Input() icon: ButtonIcon | undefined;
  @Input() iconColor: string = 'black';
  @Input() disabled: boolean = false;
  @Input() href: string | undefined;
  @Input() submitType: boolean | undefined;
  @Input() fullWidth: boolean = false;
  @Input() target: string | undefined;
  @Input() position: ButtonPosition = ButtonPosition.CENTER;
  
  constructor() {}
}
